module.exports = function (data) {
    return {
        event: 'BWSlinkClick',
        eventContext: {
            linkType: data.linkType,
            linkName: data.linkName
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/atm/link-click-mapper.js
 **/